<template>
  <div class="u-guide">
    <page-nav :nav-list="navList" />
    <div class="content">
      <news-list :prop-list="listData" />
      <Pagination :page.sync="page" :total="total" @getItems="getItems" />
    </div>
  </div>
</template>

<script>
import PageNav from '@/components/pageNav'
import NewsList from '@/components/newsList'
import Pagination from '@/components/pagination'
import { getTypeNews } from '@/apis/user'

export default {
  components: {
    PageNav,
    NewsList,
    Pagination
  },
  data() {
    return {
      page: 1,
      total: 0,
      listData: [],
      navList: ['党务指南']
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    async getItems() {
      const params = {
        limit: 10,
        location: 'party',
        newsType: 9,
        page: this.page
      }
      const data = await getTypeNews(params)
      this.listData = data.page.list
      this.total = data.page.totalCount
      // this.listData = data.list
      // this.total = data.totalCount
    }
  }
}
</script>

<style lang="scss" scoped>
  .u-guide{
    padding: 0 10px;
    .content{
      width: 90%;
      margin: 20px auto;
      overflow: hidden;
    }
  }
</style>
